var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.585 13.499.666-4.343h-4.167V6.337c0-1.188.582-2.347 2.448-2.347h1.895V.292S16.707 0 15.064 0c-3.432 0-5.676 2.08-5.676 5.846v3.31H5.573V13.5h3.815v10.5h4.696v-10.5z"
  })));
};
export default SvgFacebook;